module.exports = __webpack_public_path__ + "img/page8.b13435e0.png";